import axios from 'axios'
import Qs from 'qs'
import { Loading, Message } from 'element-ui'
import router from '../router/index'

import ApiObject from './api'
import { config } from 'jsoneditor'


/** 获取 token */
function getTokenByLocal() {
    /** sessionStorage 用于临时保存同一窗口（或标签页）的数据，在关闭窗口或标签页之后将会删除这些数据
     * 语法 sessionStorage.setItem(key,value) => 保存数据
     *     let storage =  sessionStorage.getItem(key) => 获取数据
     *     sessionStorage.removeItem(key,value) => 删除指定键的数据
     *     sessionStorage.clear() => 删除所有数据
     */
    let token = localStorage.getItem('token') || '';
    return token;
}

const baseURL = process.env.API_ROOT;

/** 创建实例 */
const serive = axios.create({
    baseURL: baseURL,
    timeout: 60000
})

/** 跨域请求时是否需要凭证
 *  凭证：指的是 cookie、HTTP身份验证、TLS客户端证书
 *  value：true => 跨域请求携带凭证
 *  为true的情况下后端要设置 Access-Control-Allow-Origin（访问控制允许来源，http请求头信息，设定允许资源共享（跨域）的源）为前端的源地址
 *  例如http://localhost:8080(全匹配)，不能使用*,而且还要设置 header('Access-Control-Allow-Credentials: true' => 开启 cookie)
 *  value：false => 跨域请求不携带凭证，返回的 response 也会忽略 cookie
 */
serive.defaults.withCredentials = false;

const Api = Object.assign(ApiObject);
const Http = {};

Object.keys(Api).forEach(key => {
    // for (let key in Api) {
    let api = Api[key];
    Http[key] = async function (params, config = {}) {
        let { url, method } = api,
            response;
        /** 序列化参数 */
        // params = Qs.stringify(params);
        // params = JSON.stringify(params)
        const currentScenicInfo = JSON.parse(localStorage.getItem("currentScenicInfo")),
            user = localStorage.getItem('user')
        if (currentScenicInfo && currentScenicInfo.scenic_num) {
            if (url !== 'background/payment-statistics' && url !== 'background/payment-refund-lst' && url !== 'background/payment-list' && url !== 'background/scenics_payment-statistics' && url !== 'background/get_scenic_statistics_accumulate' && !url.includes('admin/')) {
                params.scenic_num = currentScenicInfo.scenic_num
            }
        }

        if (user) {
            params.manager_name = user
        }
        try {
            if (method === 'post' || method === 'put' || method === 'patch') {
                response = await serive[method](url, params, config);
            } else if (method === 'delete' || method === 'get') {
                config.params = params;
                response = await serive[method](url, config);
            }
        } catch (error) {
            response = error;
        }
        return response;
    }
})

/** 请求拦截器 */
serive.interceptors.request.use(config => {
    let token = getTokenByLocal();
    if (token) {
        config.headers['token'] = token;
        config.headers['ContentType'] = "application/json;charset=utf-8";
    }
    return config;
}, error => {
    return Promise.reject(error);
});

/** 响应拦截器 */
serive.interceptors.response.use(response => {
    // 只有200才能进来这来？
    // if (response.status === 200) {
    if (response.data.code === 100) {
        return Promise.resolve(response.data);
    } else if (response.data.code === 115) {
        failHint('token已过期请重新登录！')
        router.replace('/login');
        return Promise.reject(false);
    } else {
        if (response.config.url.includes("-ex")) { // 下载文件
            return Promise.resolve(response.data);
        } else {
            failHint(response.data.message)
            return Promise.reject(false);
        }
    }
    // } 
}, error => {
    let status = error.response.status;
    if (status) {
        switch (status) {
            case 404:
                failHint('网络请求不存在~')
                console.log('网络请求不存在~') // 这里可以跳转对应页面
                break;
            case 500:
                failHint('后台故障~')
                console.log('后台故障~')
                break;
            default:
                failHint(`错误-code：${status}`)
                console.log(`错误-code：${status}`)
        }
    }
    return Promise.reject(false);
});

// let loadingInstance = showLoading();

/** 显示加载图标 */
function showLoading() {
    return Loading.service({
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0,0,0,0.7)'
    })
}

/** 隐藏加载图标 */
function hideLoading() {
    setTimeout(() => {
        showLoading().close();
    }, 0)
}

/** 接口请求成功提示 */
function successHint(message = '请求成功~') {
    Message.success({
        Message: message,
        duration: 1200,
        showClose: true,
        center: true
    })
}

/** 请求失败提示 */
function failHint(error) {
    Message.error(error)
    // Message.error(`请求失败~错误信息：${error}`)
}

export default Http;


// WEBPACK FOOTER //
// ./src/service/request.js